import React from "react"
import colors from "@constants/colors"

interface IconProps {
  strokeColor?: string
  strokeWidth?: string
  title?: string
}

export const UAGLogo: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
  strokeWidth = "1px",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 59 18"
    width="100%"
    height="100%"
    fill="none"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
  >
    <title>UAG Logo</title>
    <path
      d="M17.758 0v18H0V0h4.2v13.743h9.358V0h4.2zM24.823 13.743V11.13h9.354v2.614h-9.354zm9.354-9.486v2.615H20.62V18h17.758V0H20.619v4.257h13.558zM41.242 18V0H59v4.257H45.442v9.486H54.8V11.13h-6.779V6.872H59V18H41.242z"
      fill={strokeColor}
    />
  </svg>
)

export const Chevron: React.FC<IconProps> = ({
  strokeColor = colors.black,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
  >
    <title>Chevron Icon</title>
    <path d="M10.199 15.605l3.604-3.603-3.604-3.604" stroke={strokeColor} />
  </svg>
)

export const Close: React.FC<IconProps> = ({
  strokeWidth = "1.5",
  strokeColor = colors.black,
}: IconProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    strokeMiterlimit="10"
  >
    <title>Close Icon</title>
    <path d="M13.332 26.6673L26.6654 13.334" />
    <path d="M26.6654 26.6673L13.332 13.334" />
  </svg>
)

export const Facebook: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
  >
    <title>Facebook Icon</title>
    <path
      d="M19.1158 4H4.88421C4.6497 4 4.4248 4.09316 4.25898 4.25898C4.09316 4.4248 4 4.6497 4 4.88421V19.1158C4 19.3503 4.09316 19.5752 4.25898 19.741C4.4248 19.9068 4.6497 20 4.88421 20H12.5474V13.8246H10.4561V11.3909H12.5361V9.61404C12.5361 7.54526 13.7965 6.41965 15.6407 6.41965C16.2672 6.42151 16.8931 6.45712 17.5158 6.52632V8.68491H16.2414C15.2393 8.68491 15.0456 9.1593 15.0456 9.85825V11.4021H17.4456L17.134 13.8246H15.0456V20H19.1158C19.3503 20 19.5752 19.9068 19.741 19.741C19.9068 19.5752 20 19.3503 20 19.1158V4.88421C20 4.6497 19.9068 4.4248 19.741 4.25898C19.5752 4.09316 19.3503 4 19.1158 4V4Z"
      fill={strokeColor}
    />
  </svg>
)

export const Instagram: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
  >
    <title>Instagram Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.072 4c-2.193 0-2.467.01-3.328.049-.86.039-1.446.175-1.96.375-.53.206-.98.482-1.43.93a3.957 3.957 0 0 0-.93 1.43c-.2.514-.336 1.1-.375 1.96-.04.86-.049 1.135-.049 3.328 0 2.192.01 2.467.049 3.328.039.859.175 1.445.375 1.959.206.53.482.98.93 1.43.45.448.9.724 1.43.93.514.2 1.1.336 1.96.376.86.039 1.135.048 3.328.048 2.192 0 2.467-.01 3.328-.048.859-.04 1.445-.176 1.959-.376.53-.206.98-.482 1.43-.93.448-.45.724-.9.93-1.43.2-.514.336-1.1.376-1.96.039-.86.048-1.135.048-3.327 0-2.193-.01-2.467-.048-3.328-.04-.86-.176-1.446-.376-1.96a3.958 3.958 0 0 0-.93-1.43 3.956 3.956 0 0 0-1.43-.93c-.514-.2-1.1-.336-1.96-.375-.86-.04-1.135-.049-3.327-.049zm0 1.454c2.155 0 2.41.009 3.261.047.787.036 1.214.168 1.499.278a2.5 2.5 0 0 1 .928.604 2.5 2.5 0 0 1 .604.928c.11.285.242.712.278 1.499.039.851.047 1.106.047 3.262 0 2.155-.008 2.41-.047 3.261-.036.787-.168 1.214-.278 1.499a2.5 2.5 0 0 1-.604.928 2.5 2.5 0 0 1-.928.604c-.285.11-.712.242-1.499.278-.85.039-1.106.047-3.261.047-2.156 0-2.411-.008-3.262-.047-.787-.036-1.214-.168-1.499-.278a2.5 2.5 0 0 1-.928-.604 2.5 2.5 0 0 1-.604-.928c-.11-.285-.242-.712-.278-1.499-.038-.85-.047-1.106-.047-3.261 0-2.156.009-2.41.047-3.262.036-.787.168-1.214.278-1.499a2.5 2.5 0 0 1 .604-.928 2.5 2.5 0 0 1 .928-.604c.285-.11.712-.242 1.499-.278.851-.038 1.106-.047 3.262-.047z"
      fill={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.07 14.761a2.69 2.69 0 1 1 0-5.38 2.69 2.69 0 0 1 0 5.38zm0-6.835a4.145 4.145 0 1 0 0 8.29 4.145 4.145 0 0 0 0-8.29zM17.347 7.764a.969.969 0 1 1-1.937 0 .969.969 0 0 1 1.937 0"
      fill={strokeColor}
    />
  </svg>
)

export const Menu: React.FC<IconProps> = ({
  strokeWidth = "1.5",
  strokeColor = colors.black,
}: IconProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
  >
    <title>Menu Icon</title>
    <path d="M4 9H20.9231M4 15H14.2345" />
  </svg>
)

export const Twitter: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
  >
    <title>Twitter Icon</title>
    <path
      d="M21 6.846a7.555 7.555 0 0 1-2.128.57 3.644 3.644 0 0 0 1.63-2 7.537 7.537 0 0 1-2.355.877 3.747 3.747 0 0 0-2.706-1.142c-2.048 0-3.708 1.619-3.708 3.615 0 .283.033.56.096.824a10.617 10.617 0 0 1-7.641-3.777 3.528 3.528 0 0 0-.502 1.817 3.59 3.59 0 0 0 1.65 3.009 3.762 3.762 0 0 1-1.68-.452v.045c0 1.752 1.278 3.213 2.974 3.545a3.804 3.804 0 0 1-1.675.062c.472 1.436 1.841 2.481 3.464 2.51a7.56 7.56 0 0 1-4.605 1.548c-.3 0-.594-.017-.884-.05a10.689 10.689 0 0 0 5.683 1.623c6.82 0 10.549-5.508 10.549-10.285 0-.157-.004-.312-.011-.468A7.426 7.426 0 0 0 21 6.847z"
      fill={strokeColor}
    />
  </svg>
)

export const Youtube: React.FC<IconProps> = ({
  strokeColor = colors.offWhite,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    fill="none"
  >
    <title>Youtube Icon</title>
    <path
      d="M20.748 8.251c0-1.406-1.122-2.695-2.468-2.812a45.109 45.109 0 0 0-12.56 0 2.65 2.65 0 0 0-1.76.902 2.883 2.883 0 0 0-.708 1.91 27.975 27.975 0 0 0 0 7.498c0 1.406 1.122 2.694 2.468 2.812 4.15.585 8.41.585 12.56 0 1.346-.235 2.355-1.406 2.468-2.812a27.98 27.98 0 0 0 0-7.498zM9.757 15.515v-7.03L15.364 12l-5.607 3.515z"
      fill={strokeColor}
    />
  </svg>
)
